import React, { useState, useEffect } from "react"
import MenuIcon from '@mui/icons-material/Menu';
import {
  MobileCart,
  MobileMenuDrawer,
  MobileProfile,
  MobileSearch,
  MobileCitySelect
} from "./MobileHeaderComponents";
import mobileHeaderStyles from "./MobileHeader.module.css"

const Mobileheader = () => {
  const [openMenuDrawer, setOpenMenuDrawer] = useState(false);

  return (
    <>
      <div className={mobileHeaderStyles.mobileheader}>
        <div className={mobileHeaderStyles.topheader}>
          <div className={mobileHeaderStyles.leftSideHeader}>
            <div className={mobileHeaderStyles.iconContainer} onClick={() => setOpenMenuDrawer(true)}>
              <MenuIcon className={mobileHeaderStyles.menuIcon} />
            </div>
            <a href={process.env.RAZZLE_APP_BASE_URL} className={mobileHeaderStyles.logoAnchor}>
              <div>
                <img
                  // className={mobileHeaderStyles.logo}
                  src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/762d53ff-c9ea-45e1-ab34-2b75f0bb0754.webp"
                  alt="logo"
                  width={93}
                  height={36}
                />
              </div>
            </a>
          </div>
          <div className={mobileHeaderStyles.rightSideHeader}>
            {/* CART */}
            <MobileCart />

            {/* PROFILE */}
            <MobileProfile />
          </div>
        </div>
        <div className={mobileHeaderStyles.bottomHeader}>
          <MobileSearch />
          <MobileCitySelect />
        </div>
      </div>
      {openMenuDrawer ? <MobileMenuDrawer setOpenMobileMenuDrawer={setOpenMenuDrawer} /> : null}
    </>
  );
}

export default Mobileheader;
